import React from "react";
import { cn } from "@/lib/utils";

interface SkeletonProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  children?: React.ReactNode;
}

/**
 * Pulsing placeholder block used for loading states.
 * Mirrors the mobile API shape (`width`, `height`, `className`); on web we
 * use Tailwind's `animate-pulse` instead of Reanimated.
 *
 * Use `className` for radius (`rounded-2xl`), margin, and any layout overrides
 * — there is no separate `borderRadius` prop on web (Tailwind idiom).
 */
export function Skeleton({
  className,
  width,
  height,
  children,
}: SkeletonProps) {
  return (
    <div
      className={cn("animate-pulse rounded bg-muted/60", className)}
      style={{ width, height }}
    >
      {children}
    </div>
  );
}
